import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { FormControl, MenuItem, Select } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useSnackbar } from 'notistack';
import React, { useRef, useState } from 'react';
import useStyles from '../indexcss';

interface ComplaintDialogProps {
  open: boolean;
  onClose: () => void;
}

const ComplaintDialog: React.FC<ComplaintDialogProps> = ({ open, onClose }) => {
  const classes = useStyles();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [uploadedFileName, setUploadedFileName] = useState<string | null>(null);
  const [selectedIssueType, setSelectedIssueType] = useState<string | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleUploadIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      setUploadedFileName(files[0].name);
    }
  };

  const handleSubmit = () => {
    const success = true;
    if (success) {
      enqueueSnackbar('Submission successful!', { variant: 'success' });
    } else {
      enqueueSnackbar('Submission failed. Please try again.', { variant: 'error' });
    }
    onClose();
    setSelectedIssueType('');
  };

  const issueTypeOptions = [
    { value: 'option1', label: 'Option 1' },
    { value: 'option2', label: 'Option 2' },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogContent style={{ padding: '15px 20px' }}>
        <style>{`
          .MuiPaper-root.MuiDialog-paper {
            max-width: 508px;
          }
        `}</style>
        <Typography className={classes.dilogHeader}>Raise a Complaint</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Typography className={classes.dilogtypo}>Issue Type</Typography>
            <FormControl fullWidth variant="outlined">
              {/* <InputLabel>{selectedIssueType ? '' : 'Issue Type'}</InputLabel> */}
              <Select className={classes.customSelect} value={selectedIssueType} onChange={(event) => setSelectedIssueType(event.target.value as string)}>
                {issueTypeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography className={classes.dilogtypo}>Description of the Issue</Typography>
            <TextField placeholder="Enter Description" multiline fullWidth rows={4} className={classes.customTextArea} />
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography className={classes.dilogtypo}>Upload Supporting Document</Typography>
            <TextField
              className={classes.customText}
              placeholder="Upload Document"
              fullWidth
              variant="outlined"
              inputProps={{
                readOnly: true,
              }}
              value={uploadedFileName || ''}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" onClick={handleUploadIconClick}>
                    <FileUploadOutlinedIcon style={{ cursor: 'pointer' }} />
                  </InputAdornment>
                ),
              }}
            />
            <input ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={handleFileChange} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} className={classes.profileButton} variant="contained" color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComplaintDialog;
